const DOCUMENT_PERSONALIZED_TAG = {
  EMPLOYEE_FIRST_NAME: "{{employee_first_name}}",
  EMPLOYEE_LAST_NAME: "{{employee_last_name}}",
  EMPLOYEE_FULL_NAME: "{{employee_full_name}}",
  EMPLOYEE_EMAIL: "{{employee_email}}",
  EMPLOYEE_PHONE: "{{employee_phone}}",
  EMPLOYEE_JOINING_DATE: "{{employee_joining_date}}",
  EMPLOYEE_NOTICE_START_DATE: "{{employee_notice_start_date}}",
  EMPLOYEE_NOTICE_END_DATE: "{{employee_notice_end_date}}",
  EMPLOYEE_DESIGNATION: "{{employee_designation}}",
  EMPLOYEE_BIRTH_DATE: "{{employee_birth_date}}",

  CURRENT_DATE: "{{current_date}}",
  CURRENT_DATE_TIME: "{{current_date_time}}",
  CURRENT_TIME: "{{current_time}}",
  CURRENT_DAY: "{{current_day}}",
  CURRENT_MONTH: "{{current_month}}",
  CURRENT_YEAR: "{{current_year}}",

  MY_PROFILE_FIRST_NAME: "{{my_profile_first_name}}",
  MY_PROFILE_LAST_NAME: "{{my_profile_last_name}}",
  MY_PROFILE_FULL_NAME: "{{my_profile_full_name}}",
  MY_PROFILE_EMAIL: "{{my_profile_email}}",
  MY_PROFILE_PHONE: "{{my_profile_phone}}",
  MY_PROFILE_DEPARTMENT: "{{my_profile_department}}",
  MY_PROFILE_DESIGNATION: "{{my_profile_designation}}",
  MY_PROFILE_BIRTH_DATE: "{{my_profile_birth_date}}",
  MY_PROFILE_SIGNATURE: "{{my_profile_signature}}",

  COMPANY_NAME: "{{company_name}}",
  COMPANY_EMAIL: "{{company_email}}",
  COMPANY_WEBSITE: "{{company_website}}",
  COMPANY_PHONE: "{{company_phone}}",
  COMPANY_LOGO: "{{company_logo}}",
  COMPANY_ADDRESS: "{{company_address}}",
};

const PERSONALIZED_TAG_ID = {
  DATE_TIME: 1,
  EMPLOYEE: 2,
  MY_PROFILE: 3,
  COMPANY: 4,
};

export const PERSONALIZED_TAGS_DATE_TIME = {
  id: PERSONALIZED_TAG_ID.DATE_TIME,
  label: "Date Time",
  tags: [
    { value: DOCUMENT_PERSONALIZED_TAG.CURRENT_DATE, label: "Today Date" },
    { value: DOCUMENT_PERSONALIZED_TAG.CURRENT_DATE_TIME, label: "Current Date-Time" },
    { value: DOCUMENT_PERSONALIZED_TAG.CURRENT_TIME, label: "Current Time" },
    { value: DOCUMENT_PERSONALIZED_TAG.CURRENT_DAY, label: "Day" },
    { value: DOCUMENT_PERSONALIZED_TAG.CURRENT_MONTH, label: "Current Month" },
    { value: DOCUMENT_PERSONALIZED_TAG.CURRENT_YEAR, label: "Current Year" },
  ],
};

export const PERSONALIZED_TAGS_EMPLOYEE = {
  id: PERSONALIZED_TAG_ID.EMPLOYEE,
  label: "Employee Data",
  tags: [
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_FIRST_NAME, label: "First Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_LAST_NAME, label: "Last Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_FULL_NAME, label: "Full Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_EMAIL, label: "Email" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_PHONE, label: "Phone" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_JOINING_DATE, label: "Joining Date" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_NOTICE_START_DATE, label: "Notice Start Date" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_NOTICE_END_DATE, label: "Notice End Date" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_DESIGNATION, label: "Designation" },
    { value: DOCUMENT_PERSONALIZED_TAG.EMPLOYEE_BIRTH_DATE, label: "Birth Date" },
  ],
};

export const PERSONALIZED_TAGS_MY_PROFILE = {
  id: PERSONALIZED_TAG_ID.MY_PROFILE,
  label: "My Data",
  tags: [
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_FIRST_NAME, label: "First Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_LAST_NAME, label: "Last Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_FULL_NAME, label: "Full Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_EMAIL, label: "Email" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_PHONE, label: "Phone" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_DEPARTMENT, label: "Department" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_DESIGNATION, label: "Designation" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_BIRTH_DATE, label: "Birth Date" },
    { value: DOCUMENT_PERSONALIZED_TAG.MY_PROFILE_SIGNATURE, label: "Signature" },
  ],
};

export const PERSONALIZED_TAGS_COMPANY = {
  id: PERSONALIZED_TAG_ID.COMPANY,
  label: "Company Data",
  tags: [
    { value: DOCUMENT_PERSONALIZED_TAG.COMPANY_NAME, label: "Name" },
    { value: DOCUMENT_PERSONALIZED_TAG.COMPANY_EMAIL, label: "Email" },
    { value: DOCUMENT_PERSONALIZED_TAG.COMPANY_WEBSITE, label: "Website" },
    { value: DOCUMENT_PERSONALIZED_TAG.COMPANY_PHONE, label: "Phone" },
    { value: DOCUMENT_PERSONALIZED_TAG.COMPANY_LOGO, label: "Logo" },
    { value: DOCUMENT_PERSONALIZED_TAG.COMPANY_ADDRESS, label: "Address" },
  ],
};

export const DOCUMENT_TEMPLATE_TAGS = [PERSONALIZED_TAGS_DATE_TIME, PERSONALIZED_TAGS_EMPLOYEE, PERSONALIZED_TAGS_MY_PROFILE, PERSONALIZED_TAGS_COMPANY];
